module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./OpLog.js"));
	}, "OpLog");
}